import mikePic from "@/public/images/artists/mike.jpg";
import { Artist } from "@/types/types";

export const mike = {
  id: "226",
  name: "Mike",
  image: mikePic,
  description: `Mike's voice is airy and soulful with a raw, timeless quality. His deep gravelly tone moves effortlessly from heartfelt ballads to passionate bluesy moments.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fmike-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: [
        "Dance",
        "Soul",
        "Indie",
        "Folk",
        "Blues",
        "Unprocessed",
        "Airy",
        "Deep",
        "Afrobeat",
      ],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Bass",
        high: "Mid",
      },
      specific: {
        low: 50,
        high: 67,
      },
      sweetSpot: 61,
    },
  },
} as const satisfies Artist;
